/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} EuropeInputs */

const en_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europe`)
};

const es_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

const fr_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europe`)
};

const de_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

const ja_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヨーロッパ`)
};

const zh_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`欧洲`)
};

const ar_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أوروبا`)
};

const id_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eropa`)
};

const it_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

const ru_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Европа`)
};

const pt_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Europa`)
};

const ko_europe = /** @type {(inputs: EuropeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`유럽`)
};

/**
* | output |
* | --- |
* | "Europe" |
*
* @param {EuropeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const europe = /** @type {((inputs?: EuropeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<EuropeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_europe(inputs)
	if (locale === "es") return es_europe(inputs)
	if (locale === "fr") return fr_europe(inputs)
	if (locale === "de") return de_europe(inputs)
	if (locale === "ja") return ja_europe(inputs)
	if (locale === "zh") return zh_europe(inputs)
	if (locale === "ar") return ar_europe(inputs)
	if (locale === "id") return id_europe(inputs)
	if (locale === "it") return it_europe(inputs)
	if (locale === "ru") return ru_europe(inputs)
	if (locale === "pt") return pt_europe(inputs)
	return ko_europe(inputs)
});